<template>
  <div>
    <div class="ui secondary pointing top attached tabular menu three item">
      <a class="item active" data-tab="rpd_lib">Рабочие программы дисциплин</a>
      <a class="item" data-tab="rpp_lib">Рабочие программы практик</a>
      <a class="item" data-tab="rpg_lib">Рабочие программы ГИА</a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="rpd_lib">
      <div class="ui secondary pointing top attached tabular menu two item">
        <a class="item" v-on:click="getRPDs" data-tab="first_rpd">Список РПД на согласование</a>
        <a class="item" v-on:click="getRPDsByTeacher" data-tab="second_rpd">Сортировать по Преподавателям</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="first_rpd">
        <div class="ui styled fluid accordion">
          <div v-for="prog in rpd">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="35%">
                  {{ prog.main_info.discipline }}
                </td>
                <td width="35%">
                  {{ prog.main_info.speciality }}
                </td>
                <td width="20%">
                  {{ prog.main_info.creator.fio }}
                </td>
                <td width="8%">
                  {{ prog.main_info.year }}
                </td>
              </tr>
            </div>
            <div class="content">
              <tr>
                <td width="15%"><h4>Отправленно на согласование</h4></td>
                <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                <td width="25%">
                  <h4>
                    Отправлено {{prog.library_agreed_times}} раз
                  </h4>
                </td>
              </tr>
              <div class="ui fitted divider"></div>
              <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPD(prog.id, rpd.indexOf(prog), prog.library_agreed_times, prog)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPD(prog.id, rpd.indexOf(prog), prog)">
                  Согласовать
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="second_rpd">
        <div class="ui styled fluid accordion">
          <div v-for="rpd in rpdSortTeacher">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="98%">
                  <h3>{{rpd.name}}</h3>
                </td>
              </tr>
            </div>
            <div class="content">
              <div v-for="prog in rpd.arr">
                <div class="title">
                  <tr>
                    <td width="2%">
                      <i class="dropdown icon"></i>
                    </td>
                    <td width="35%">
                      {{ prog.main_info.discipline }}
                    </td>
                    <td width="35%">
                      {{ prog.main_info.speciality }}
                    </td>
                    <td width="20%">
                      {{ prog.main_info.creator.fio }}
                    </td>
                    <td width="8%">
                      {{ prog.main_info.year }}
                    </td>
                  </tr>
                </div>
                <div class="content">
                  <tr>
                    <td width="15%"><h4>Отправленно на согласование</h4></td>
                    <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                    <td width="25%">
                      <h4>
                        Отправлено {{prog.library_agreed_times}} раз
                      </h4>
                    </td>
                  </tr>
                  <div class="ui fitted divider"></div>
                  <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
                  <div class="ui fitted divider"></div>
                  <div>
                    <button class="ui button negative" v-on:click="denyRPDTeacher(prog.id, rpd.arr.indexOf(prog), prog.library_agreed_times, rpd.name, prog)">
                      Отклонить
                    </button>
                    <button class="ui right floated button positive" v-on:click="agreedRPDTeacher(prog.id, rpd.arr.indexOf(prog), rpd.name, prog)">
                      Согласовать
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpp_lib">
      <div class="ui secondary pointing top attached tabular menu two item">
        <a class="item" v-on:click="getRPPs" data-tab="first_rpp">Список РПП на согласование</a>
        <a class="item" v-on:click="getRPPsByTeacher" data-tab="second_rpp">Сортировать по Преподавателям</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="first_rpp">
        <div class="ui styled fluid accordion">
          <div v-for="prog in rpp">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="35%">
                  {{ prog.main_info.discipline }}
                </td>
                <td width="35%">
                  {{ prog.main_info.speciality }}
                </td>
                <td width="20%">
                  {{ prog.main_info.creator.fio }}
                </td>
                <td width="8%">
                  {{ prog.main_info.year }}
                </td>
              </tr>
            </div>
            <div class="content">
              <tr>
                <td width="15%"><h4>Отправленно на согласование</h4></td>
                <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                <td width="25%">
                  <h4>
                    Отправлено {{prog.library_agreed_times}} раз
                  </h4>
                </td>
              </tr>
              <div class="ui fitted divider"></div>
              <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPP(prog.id, rpp.indexOf(prog), prog.library_agreed_times, prog)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPP(prog.id, rpp.indexOf(prog), prog)">
                  Согласовать
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="second_rpp">
        <div class="ui styled fluid accordion">
          <div v-for="rpp in rppSortTeacher">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="98%">
                  <h3>{{rpp.name}}</h3>
                </td>
              </tr>
            </div>
            <div class="content">
              <div v-for="prog in rpp.arr">
                <div class="title">
                  <tr>
                    <td width="2%">
                      <i class="dropdown icon"></i>
                    </td>
                    <td width="35%">
                      {{ prog.main_info.discipline }}
                    </td>
                    <td width="35%">
                      {{ prog.main_info.speciality }}
                    </td>
                    <td width="20%">
                      {{ prog.main_info.creator.fio }}
                    </td>
                    <td width="8%">
                      {{ prog.main_info.year }}
                    </td>
                  </tr>
                </div>
                <div class="content">
                  <tr>
                    <td width="15%"><h4>Отправленно на согласование</h4></td>
                    <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                    <td width="25%">
                      <h4>
                        Отправлено {{prog.library_agreed_times}} раз
                      </h4>
                    </td>
                  </tr>
                  <div class="ui fitted divider"></div>
                  <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
                  <div class="ui fitted divider"></div>
                  <div>
                    <button class="ui button negative" v-on:click="denyRPPTeacher(prog.id, rpp.arr.indexOf(prog), prog.library_agreed_times, rpp.name, prog)">
                      Отклонить
                    </button>
                    <button class="ui right floated button positive" v-on:click="agreedRPPTeacher(prog.id, rpp.arr.indexOf(prog), rpp.name, prog)">
                      Согласовать
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpg_lib">
      <div class="ui secondary pointing top attached tabular menu two item">
        <a class="item" v-on:click="getRPGs" data-tab="first_rpg">Список РПГ на согласование</a>
        <a class="item" v-on:click="getRPGsByTeacher" data-tab="second_rpg">Сортировать по Преподавателям</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="first_rpg">
        <div class="ui styled fluid accordion">
          <div v-for="prog in rpg">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="35%">
                  {{ prog.name }}
                </td>
                <td width="35%">
                  {{ prog.main_info.speciality }}
                </td>
                <td width="20%">
                  {{ prog.main_info.creator.fio }}
                </td>
                <td width="8%">
                  {{ prog.main_info.year }}
                </td>
              </tr>
            </div>
            <div class="content">
              <tr>
                <td width="15%"><h4>Отправленно на согласование</h4></td>
                <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                <td width="25%">
                  <h4>
                    Отправлено {{prog.library_agreed_times}} раз
                  </h4>
                </td>
              </tr>
              <div class="ui fitted divider"></div>
              <h5>Рекомендуемая литература для ВКР</h5>
              <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
              <div v-if="prog.main_info.speciality_code === '40.03.01' || prog.main_info.speciality_code === '41.03.01' || prog.main_info.speciality_code === '41.04.01' || prog.main_info.speciality_code === '46.03.01'">
                <h5>Рекомендуемая литература для ГОС</h5>
                <vue-editor v-model="prog.literature_gos_old" :editor-toolbar="customToolbar"/>
              </div>
              <div class="ui fitted divider"></div>
              <div>
                <button class="ui button negative" v-on:click="denyRPG(prog.id, rpg.indexOf(prog), prog.library_agreed_times, prog)">
                  Отклонить
                </button>
                <button class="ui right floated button positive" v-on:click="agreedRPG(prog.id, rpg.indexOf(prog), prog)">
                  Согласовать
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="second_rpg">
        <div class="ui styled fluid accordion">
          <div v-for="rpg in rpgSortTeacher">
            <div class="title">
              <tr>
                <td width="2%">
                  <i class="dropdown icon"></i>
                </td>
                <td width="98%">
                  <h3>{{rpg.name}}</h3>
                </td>
              </tr>
            </div>
            <div class="content">
              <div v-for="prog in rpg.arr">
                <div class="title">
                  <tr>
                    <td width="2%">
                      <i class="dropdown icon"></i>
                    </td>
                    <td width="35%">
                      {{ prog.name }}
                    </td>
                    <td width="35%">
                      {{ prog.main_info.speciality }}
                    </td>
                    <td width="20%">
                      {{ prog.main_info.creator.fio }}
                    </td>
                    <td width="8%">
                      {{ prog.main_info.year }}
                    </td>
                  </tr>
                </div>
                <div class="content">
                  <tr>
                    <td width="15%"><h4>Отправленно на согласование</h4></td>
                    <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
                    <td width="25%">
                      <h4>
                        Отправлено {{prog.library_agreed_times}} раз
                      </h4>
                    </td>
                  </tr>
                  <div class="ui fitted divider"></div>
                  <vue-editor v-model="prog.literature_old" :editor-toolbar="customToolbar"/>
                  <div class="ui fitted divider"></div>
                  <div>
                    <button class="ui button negative" v-on:click="denyRPGTeacher(prog.id, rpg.arr.indexOf(prog), prog.library_agreed_times, rpg.name, prog)">
                      Отклонить
                    </button>
                    <button class="ui right floated button positive" v-on:click="agreedRPGTeacher(prog.id, rpg.arr.indexOf(prog), rpg.name, prog)">
                      Согласовать
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui modal" id="deny_lib_modal">
      <div class="ui header">Отклонить?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>Оставить отзыв (опционально)</label>
            <textarea v-model="deny_text"></textarea>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
    <div class="ui modal" id="agreed_modal">
      <div class="ui header">Согласовать?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <p>Подтвердите согласование</p>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui negative button">
          Нет
        </div>
        <div class="ui positive right labeled icon button">
          Да
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
    <div class="ui modal" id="error_library_modal">
      <div class="ui header">Произошла ошибка</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>{{error_message_text}}</label>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";

export default {
  name: "library_agreed_rpd",
  components: { VueEditor },
  data: () => ({
    rpd: [],
    rpdSortTeacher: [],
    rpp: [],
    rppSortTeacher: [],
    rpg: [],
    rpgSortTeacher: [],
    deny_text: "",
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4] }],

      [{ size: ["small", false, "large"] }],

      ["bold", "italic", "underline"],

      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],

      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

      [{ script: "sub" }, { script: "super" }],

      [{ indent: "-1" }, { indent: "+1" }],

      ["link"],

      ["clean"]
    ],
    error_message_text: "",
  }),
  methods: {
    getRPDs() {
      if (!this.rpd.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed'
        }).then((response) => {
          this.rpd = response.data.rpd
          this.rpd.sort(function (a, b) {
            return a.id - b.id;
          });
        }).catch((error) => {
          return error;
        });
      }
    },
    getRPDsByTeacher() {
      if (!this.rpd.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed'
        }).then((response) => {
          this.rpd = response.data.rpd
          this.rpd.sort(function (a, b) {
            return a.id - b.id;
          });
          this.teacherRPD = true;
          this.sortedRPDTeacher()
        }).catch((error) => {
          return error;
        });
      }
      else{
        this.sortedRPDTeacher()
      }
    },
    denyRPDTeacher(id, index, times, rpd, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpdSortTeacher[this.rpdSortTeacher.findIndex(p=>p.name === rpd)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPDTeacher(id, index, rpd, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpdSortTeacher[this.rpdSortTeacher.findIndex(p=>p.name === rpd)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    denyRPD(id, index, times, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpd.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPD(id, index, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpd.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    sortedRPDTeacher(){
      let uniqTeacher = []
      let sortedRPD = []
      this.rpd.forEach(prog=>{
        uniqTeacher.push(prog.main_info.creator.fio)
      })
      uniqTeacher = uniqTeacher.filter(this.uniq);
      uniqTeacher.forEach(fio=>{
        let specArr = []
        this.rpd.forEach(prog=>{
          if (fio === prog.main_info.creator.fio){
            specArr.push(prog)
          }
        })
        sortedRPD.push({name: fio,
          arr: specArr
        })
      })
      sortedRPD.sort(function(a, b) {
        return a.name - b.name;
      });
      this.rpdSortTeacher = sortedRPD
    },
    getRPGs() {
      if (!this.rpg.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed_rpg'
        }).then((response) => {
          this.rpg = response.data.rpg
          this.rpg.sort(function (a, b) {
            return a.id - b.id;
          });
        }).catch((error) => {
          return error;
        });
      }
    },
    getRPGsByTeacher() {
      if (!this.rpg.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed_rpg'
        }).then((response) => {
          this.rpg = response.data.rpg
          this.rpg.sort(function (a, b) {
            return a.id - b.id;
          });
          this.sortedRPGTeacher()
        }).catch((error) => {
          return error;
        });
      }
      else{
        this.sortedRPGTeacher()
      }
    },
    denyRPGTeacher(id, index, times, rpg, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpgSortTeacher[this.rpgSortTeacher.findIndex(p=>p.name === rpg)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPGTeacher(id, index, rpg, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpgSortTeacher[this.rpgSortTeacher.findIndex(p=>p.name === rpg)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    denyRPG(id, index, times, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpg.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPG(id, index, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpg.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    sortedRPGTeacher(){
      let uniqTeacher = []
      let sortedRPG = []
      this.rpg.forEach(prog=>{
        uniqTeacher.push(prog.main_info.creator.fio)
      })
      uniqTeacher = uniqTeacher.filter(this.uniq);
      uniqTeacher.forEach(fio=>{
        let specArr = []
        this.rpg.forEach(prog=>{
          if (fio === prog.main_info.creator.fio){
            specArr.push(prog)
          }
        })
        sortedRPG.push({name: fio,
          arr: specArr
        })
      })
      sortedRPG.sort(function(a, b) {
        return a.name - b.name;
      });
      this.rpgSortTeacher = sortedRPG
    },
    getRPPs() {
      if (!this.rpp.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed_rpp'
        }).then((response) => {
          this.rpp = response.data.rpp
          this.rpp.sort(function (a, b) {
            return a.id - b.id;
          });
        }).catch((error) => {
          return error;
        });
      }
    },
    getRPPsByTeacher() {
      if (!this.rpp.length) {
        axios({
          method: 'get',
          url: '/programms/library_agreed_rpp'
        }).then((response) => {
          this.rpp = response.data.rpp
          this.rpp.sort(function (a, b) {
            return a.id - b.id;
          });
          this.sortedRPPTeacher()
        }).catch((error) => {
          return error;
        });
      }
      else{
        this.sortedRPPTeacher()
      }
    },
    denyRPPTeacher(id, index, times, rpp, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rppSortTeacher[this.rppSortTeacher.findIndex(p=>p.name === rpp)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPPTeacher(id, index, rpp, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rppSortTeacher[this.rppSortTeacher.findIndex(p=>p.name === rpp)].arr.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    denyRPP(id, index, times, prog){
      this.deny_text = "";
      $('#deny_lib_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                library_agreed: false,
                library_comment: this.deny_text,
                library_agreed_times: times + 1,
                literature_old: prog.literature_old,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpp.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPP(id, index, prog){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      $('#agreed_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                library_agreed: true,
                literature_old: prog.literature_old,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204) {
              this.rpp.splice(index, 1)
            }else{
              $('#error_library_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_library_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    sortedRPPTeacher(){
      let uniqTeacher = []
      let sortedRPP = []
      this.rpp.forEach(prog=>{
        uniqTeacher.push(prog.main_info.creator.fio)
      })
      uniqTeacher = uniqTeacher.filter(this.uniq);
      uniqTeacher.forEach(fio=>{
        let specArr = []
        this.rpp.forEach(prog=>{
          if (fio === prog.main_info.creator.fio){
            specArr.push(prog)
          }
        })
        sortedRPP.push({name: fio,
          arr: specArr
        })
      })
      sortedRPP.sort(function(a, b) {
        return a.name - b.name;
      });
      this.rppSortTeacher = sortedRPP
    },
    uniq(value, index, self) {
      return self.indexOf(value) === index;
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>